import {
  Dialog, DialogTitle, Divider, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer,
  TableHead, TablePagination, TableRow, Typography, ToggleButton
} from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import BillingService from "../../../Services/MasterBilling/BillingService";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import Home from "../../home/Home";
import Snacbar from "../../Snacbar";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: theme.palette.common.black,
    padding: theme.spacing(0.5),
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
}));

function Unitofmeasurement() {
  const mystyle = {
    border: " 1px solid black",
    width: "12rem", fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "red", fontFamily: 'Times New Roman',
  };
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');
  const [Values, setValues] = useState({
    old_unitcode: '',
    unitcode: '',
    unitname: '',
  });
  const [UOMDetails, getUOMDetails] = useState([]);
  const [error, setError] = useState({
    unitcode: '',
    unitname: '',
  })
  const [UomSaveDsa, setUomSaveDsa] = useState(false);
  const [UomUpdateDsa, setUomUpdateDsa] = useState(true);
  const [UomDeleteDsa, setUomDeleteDsa] = useState(true);
  const [Filtereddetails, setFiltereddetails] = useState([]);

  const [uomSave, setUomSave] = useState(false);
  const [uomUpdate, setUomUpdate] = useState(false);
  const [uomDelete, setUomDelete] = useState(false);

  const unitcodehandlechange = (e) => {
    setValues({ ...Values, unitcode: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
  };
  const unitnamehandlechange = (e) => {
    setValues({ ...Values, unitname: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
  };

  //getData
  const getData = async () => {
    BillingService.getUOM().then((res) => {
      getUOMDetails(res.data);
      setFiltereddetails(res.data);
    })
  }

  useEffect(() => {
    const getData = async () => {
      BillingService.getUOM().then((res) => {
        getUOMDetails(res.data);
        setFiltereddetails(res.data);

      })
    }
    getData();
  }, []);

  //tableClickHandle
  const EditUomDetails = (item) => {
    setUomSaveDsa(true); setUomUpdateDsa(false); setUomDeleteDsa(false);
    setUomSave(false); setUomUpdate(false); setUomDelete(false);
    setValues({ ...Values, old_unitcode: item.unitCode, unitcode: item.unitCode, unitname: item.unitName });
    setError({ ...error, unitcode: false, unitname: false });
  }
  //icon
  const deleteicon = () => {
    return <DeleteOutlineRoundedIcon style={{ color: 'red' }} />
  }
  //clickHandle
  const validate = () => {
    if (Values.unitcode !== '') {
      if (Values.unitname !== '') {
        return true;
      } else {
        document.getElementById('UnitName').focus();
        setError({ ...error, unitname: true });
        setOpen(true); setSeverity('warning'); setMessage('Please Enter a UnitName..!')
      }
    } else {
      document.getElementById('UnitCode').focus();
      setError({ ...error, unitcode: true });
      setOpen(true); setSeverity('warning'); setMessage('Please Enter a UnitCode..!')
    }
    return false;
  }

  const UomSave = () => {
    if (validate() === true) {
      setUomSaveDsa(true);
      setUomSave(true);
      let details = { unitCode: Values.unitcode, unitName: Values.unitname }
      BillingService.insertUOM(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Failed To Delete');
        } refresh(); getData();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh(); getData();
      })
    }
  }
  const UomUpdate = () => {
    if (validate() === true) {
      setUomUpdateDsa(true);
      setUomUpdate(true);
      let details = { oldUnitCode: Values.old_unitcode, unitCode: Values.unitcode, unitName: Values.unitname }
      BillingService.updateUOM(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Updation Failed');
        } refresh(); getData();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh(); getData();
      })
    }
  }
  const UomDelete = () => {
    setUomDeleteDsa(true);
    setUomDelete(true);
    setalertopen(true)
  }
  const refresh = () => {
    setPage(0)
    setUomSaveDsa(false); setUomUpdateDsa(true); setUomDeleteDsa(true);
    setUomSave(false); setUomUpdate(false); setUomDelete(false);
    setValues({ ...Values, old_unitcode: '', unitcode: '', unitname: '' });
    setError({ ...error, unitcode: false, unitname: false });
  }

  //handleClose/open
  const handleClose = () => {
    setOpen(false);
  }

  //table search
  const UnitCodesearch = () => {
    return <input className="searchBoxes" onChange={(e) => { UnitCodeOnchange(e.target.value) }} placeholder="Search" />
  }
  const UnitNamesearch = () => {
    return <input className="searchBoxes" onChange={(e) => { UnitNameOnchange(e.target.value) }} placeholder="Search" />
  }
  ///
  const UnitCodeOnchange = (searchedVal) => {
    const FilterValues = UOMDetails.filter((trns) => {
      return trns.unitCode.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (searchedVal.length < 1) {
      setFiltereddetails(UOMDetails)
    } else {
      setFiltereddetails(FilterValues)
    }
  }
  const UnitNameOnchange = (serachedVal) => {
    const FilterValues = UOMDetails.filter((trns) => {
      return trns.unitName.toString().toLowerCase().includes(serachedVal.toLowerCase())
    })
    if (serachedVal.length < 1) {
      setFiltereddetails(UOMDetails)
    } else {
      setFiltereddetails(FilterValues)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  //alertbox
  const [alertopen, setalertopen] = useState(false);

  const alertonClickOpen = (item) => {
    setValues({ ...Values, old_unitcode: item.unitCode })
    setalertopen(true)
  }

  const alertNoOnClick = () => {
    refresh();
    setalertopen(false)
  }

  const alertYesOnClick = () => {
    BillingService.deleteUOM(Values.old_unitcode).then((res) => {
      const message = res.data.message;
      if (message.toString() === 'SUCCESS') {
        setOpen(true); setSeverity('success'); setMessage(message);
      } else {
        setOpen(true); setSeverity('error'); setMessage('Failed To Delete');
      } refresh(); getData();
    }).catch(error => {
      setOpen(true); setSeverity('error'); setMessage(error.message); refresh(); getData();
    })
    setalertopen(false)
  }

  const navigate = useNavigate();
  const BackBotton = () => {
    navigate('/qutationForwarder');
  }
  const ForwordBotton = () => {
    navigate('/Account');
  }
  return (
    <div>
      <Dialog open={alertopen}>
        <DialogTitle>
          <center style={{ fontFamily: 'Times New Roman' }}><h6>ARE YOU SURE,</h6></center>
          <h6 style={{ fontFamily: 'Times New Roman' }}>YOU WANT TO DELETE ?</h6>
          <Divider color="#FDA228" sx={{ height: 2 }} />
        </DialogTitle>
        <div className="form-inline p-1">
          <center><Button variant="danger" className="p-1 mb-2 mr-1" style={{ width: '50px', fontFamily: 'Times New Roman' }} onClick={alertYesOnClick}>Yes</Button>&nbsp;
            <Button variant="success" className="p-1 mb-2 " style={{ width: '50px', fontFamily: 'Times New Roman' }} onClick={alertNoOnClick}>No</Button></center>
        </div>
      </Dialog>
      <Home /><Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
      <div style={{ paddingLeft: "80px" }}>
      <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
        <ItemPap>
          <Grid container>
            <Grid xs={4} style={{ marginTop: "1rem" }}>
              <Row>
                <Col xs={1}>
                  {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small"> <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px',marginLeft:'5px',fontFamily: 'Times New Roman', }} /> </ToggleButton> */}
                </Col>
                <Col xs={11}>
                  <Typography color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"} style={{ fontFamily: 'Times New Roman' }}>
                    UOM Details Entry
                  </Typography><hr></hr>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={4}>
                  <label style={mystyle1}>Unit Code</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle} value={Values.unitcode}
                    id='UnitCode' onChange={unitcodehandlechange} />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={4}>
                  <label style={mystyle1}>Unit Name</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle} value={Values.unitname}
                    id='UnitName' onChange={unitnamehandlechange} />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col lg={1}></Col>
                <Col lg={10}>
                  <Button style={{ fontFamily: 'Times New Roman' }} variant="success" size="sm" disabled={UomSaveDsa} onClick={UomSave}>
                    {uomSave ? 'Processing..' : 'Save'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman' }} variant="primary" size="sm" disabled={UomUpdateDsa} onClick={UomUpdate}>
                    {uomUpdate ? 'Processing..' : 'Update'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman' }} variant="danger" size="sm" disabled={UomDeleteDsa} onClick={UomDelete}>
                    {uomDelete ? 'Processing..' : 'Delete'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman' }} variant="secondary" size="sm" onClick={refresh}>
                    Refresh
                  </Button>
                </Col>
                <Col lg={1}></Col>
              </Row>
            </Grid>

            <Grid xs={8} style={{ marginTop: "1rem" }}>
              <ItemPap1>
                <Row>
                  <Col xs={11}>
                    <Typography color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"} style={{ fontFamily: 'Times New Roman' }}>
                      Existing  UOM Details
                    </Typography>
                  </Col>
                  <Col xs={1}>
                    {/* <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small"> 
                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px'}} /></ToggleButton>  */}
                  </Col>
                </Row>
                <TableContainer sx={{ height: 360 }} style={{ marginTop: "1px" }}>
                  <Table stickyHeader className="table table-bordered">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell style={{ width: "1rem" }}>SlNo</StyledTableCell>
                        <StyledTableCell>Unit Code {UnitCodesearch()}</StyledTableCell>
                        <StyledTableCell>Unit Name {UnitNamesearch()}</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center' }}>Actions</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {Filtereddetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((item, index) => (
                          <StyledTableRow hover key={item.serialNumber} onClick={() => EditUomDetails(item)}>
                            <StyledTableCell style={{ width: "1rem", textAlign: 'center' }}>{item.serialNumber}</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>{item.unitCode}</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>{item.unitName}</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}><lu onClick={() => alertonClickOpen(item)}>{deleteicon()}</lu></StyledTableCell>
                          </StyledTableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  showFirstButton
                  showLastButton
                  component='div'
                  count={Filtereddetails.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onChangeRowsPerpage={handleChangeRowsPerPage}
                />
              </ItemPap1>
            </Grid>
          </Grid>
        </ItemPap>
      </div>
    </div>
  );
}

export default Unitofmeasurement;
